import * as cx from 'classnames';
import * as heartslUrls from 'mk2/apps/hearts/urls';
import * as mailUrls from 'mk2/apps/mail/urls';
import * as wallUrls from 'mk2/apps/wall/urls';
import AvatarImg from 'mk2/components/AvatarImg';
import styles from 'mk2/components/NotificationMenu.mscss';
import { CompatibleLink } from 'mk2/containers/SiteMenu/SiteMenu';
import Loadable from 'mk2/helpers/Loadable';
import { url } from 'mk2/helpers/urls';
import { UserEntity } from 'mk2/schemas';
import * as React from 'react';

/* UserMenu is displayed on user interaction - so we can code split it safely */
const UserMenu = Loadable({
    loader: () => import('mk2/components/UserMenu' /* webpackChunkName: "components.UserMenu" */),
    modules: ['mk2/components/UserMenu'],
    webpack: () => [ require.resolveWeak('mk2/components/UserMenu') ],
});

interface OwnProps {
    mobile?: boolean;
    heartsCount: number;
    unreadMails: number;
    wallStatusNews: number;
    fluxibleCompatibility: boolean;
    requestUser: UserEntity;
    activeSection: string;
    activeItem: string;

    onItemClick();
    relocateWithNextParam(href: string);
}

type Props = OwnProps;

interface State {
    userbarOpened: boolean;
}

class NotificationMenu extends React.Component<Props, State> {

    public static defaultProps: Partial<OwnProps> = {
        mobile: false,
    };

    public state: State = {
        userbarOpened: false,
    };

    public render() {
        const {
            mobile, heartsCount, unreadMails, fluxibleCompatibility, requestUser, wallStatusNews,
            activeItem, activeSection,
            onItemClick, relocateWithNextParam,
        } = this.props;

        return (
            <div className={cx(styles.NotificationMenu)}>
                <CompatibleLink
                    onClick={onItemClick}
                    fluxibleCompatibility={fluxibleCompatibility}
                    to={!fluxibleCompatibility ? heartslUrls.hearts : relocateWithNextParam(heartslUrls.hearts)}
                    className={cx(styles.NotificationMenu__userIcon, 'topmenu-userIcon', mobile && styles['NotificationMenu__userIcon--mobile'], (activeSection === 'hearts') ? cx(styles['NotificationMenu__userIcon--active'], 'topmenu-activeLink') : null)}
                >
                    <i className={cx(styles.NotificationMenu__userIcon__icon, 'fa', 'fa-heart-o')}/>
                    {(heartsCount > 0) ? (<span className={cx(styles.NotificationMenu__notify, styles['NotificationMenu__notify--hearts'], styles['NotificationMenu__notify--heartsMobile'])}>{heartsCount}</span>) : null}
                </CompatibleLink>
                <CompatibleLink
                    fluxibleCompatibility={fluxibleCompatibility}
                    onClick={onItemClick}
                    to={url(mailUrls.mailBox, {username: requestUser.username, folder: 'inbox'})}
                    className={cx(styles.NotificationMenu__userIcon, 'topmenu-userIcon', mobile && styles['NotificationMenu__userIcon--mobile'], (activeSection === 'mail') ? cx(styles['NotificationMenu__userIcon--active'], 'topmenu-activeLink') : null)}
                >
                    <i className={cx(styles.NotificationMenu__userIcon__icon, 'fa', 'fa-envelope-o')}/>
                    {(unreadMails > 0) ? (<span className={styles.NotificationMenu__notify}>{unreadMails}</span>) : null}
                </CompatibleLink>
                <CompatibleLink
                    fluxibleCompatibility={fluxibleCompatibility}
                    onClick={onItemClick}
                    to={url(wallUrls.wallMentions, {username: requestUser.username})}
                    className={cx(styles.NotificationMenu__userIcon, 'topmenu-userIcon', mobile && styles['NotificationMenu__userIcon--mobile'], (activeSection === 'wall') ? cx(styles['NotificationMenu__userIcon--active'], 'topmenu-activeLink') : null)}
                >
                    <i className={cx(styles.NotificationMenu__userIcon__icon, 'fa', 'fa-bell-o')}/>
                    {(wallStatusNews > 0) ? (<span className={styles.NotificationMenu__notify}>{wallStatusNews}</span>) : null}
                </CompatibleLink>

                <div className={cx(styles.NotificationMenu__userMenu, mobile && styles['NotificationMenu__userMenu--mobile'])}>
                    <button type="button" className={styles['NotificationMenu__userMenu--avatarCtt']} onClick={this.onUserMenuClick}>
                        <AvatarImg className={styles['NotificationMenu__userMenu--avatar']} size={28} user={requestUser}/>
                    </button>
                    {this.state.userbarOpened && (
                        <UserMenu
                            requestUser={requestUser}
                            fluxibleCompatibility={fluxibleCompatibility}
                            activeItem={activeItem}
                            activeSection={activeSection}
                            onItemClick={onItemClick}
                        />
                    )}
                </div>
            </div>
        );
    }

    public close() {
        this.setState({
            userbarOpened: false,
        });
    }

    private onUserMenuClick = () => {
        this.setState({
            userbarOpened: !this.state.userbarOpened,
        });
    };

}

export default NotificationMenu;
